import React from 'react'

const TrainConfiguration = () => {
    return (
        <div>TrainConfiguration</div>
    )
}

export default TrainConfiguration